import { render, staticRenderFns } from "./TheLightFooter.vue?vue&type=template&id=50ff9000&functional=true"
import script from "./TheLightFooter.vue?vue&type=script&lang=js"
export * from "./TheLightFooter.vue?vue&type=script&lang=js"
import style0 from "./TheLightFooter.vue?vue&type=style&index=0&id=50ff9000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports